import { ImageDesignTokens } from '@primeuix/themes/aura/image';

export const imageTokens: ImageDesignTokens = {
  root: {
    transitionDuration: '{transition.duration}',
  },
  preview: {
    icon: {
      size: '1.5rem',
    },
    mask: {
      background: '{mask.background}',
      color: '{mask.color}',
    },
  },
  toolbar: {
    position: {
      left: 'auto',
      right: '1rem',
      top: '1rem',
      bottom: 'auto',
    },
    blur: '8',
    background: 'rgba(255, 255, 255, 0.1)',
    borderColor: 'rgba(255, 255, 255, 0.2)',
    borderWidth: '1px',
    borderRadius: '30px',
    padding: '0.5rem',
    gap: '0.5rem',
  },
  action: {
    hoverBackground: 'rgba(255, 255, 255, 0.1)',
    hoverColor: '{surface.0}',
    color: '{surface.50}',
    size: '3rem',
    iconSize: '1.5rem',
    borderRadius: '{image.action.size} / 2',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
  },
};
